import React from "react"
import { Block, BlockWrapper, Btn } from "./style"
import { BusUrbano, BusInterprovincial, BusParaPersonalDeLima } from "../../../data/buses"

const buses = [BusUrbano, BusInterprovincial, BusParaPersonalDeLima]

const TipoBuses = () => {
  return (
    <>
      {buses.map((bus, key) => {
        const item = bus.detailsItems[0]
        return (
          <BlockWrapper key={key} className="section fp-auto-height">
            <Block>
              <div className="col1">
                <img src={item.imgHome || item.img} alt={item.title} />
              </div>
              <div className="col2">
                <div className="row1">
                  <h3>{item.title}</h3>
                  <p>{bus.detailsText[0]}</p>
                </div>
                <div className="row2">
                  <div className="box__btn">
                    <Btn to={item.url}>Ver M&aacute;s</Btn>
                  </div>
                </div>
              </div>
            </Block>
          </BlockWrapper>
        )
      })}
    </>
  )
}
export default TipoBuses
